import { gql } from 'apollo-angular';

export const GET_EMPLOYEES = gql`
  query getEmployees($search: String, $filter: EmployeeFilter) {
    getEmployees(search: $search, filter: $filter) {
      id
      employeeCode
      firstName
      lastName
      middleName
      dateOfBirth
      gender
      email
    }
  }
`;

export const GET_ALL_EMPLOYEES = gql`
  query getAllEmployees($search: String, $departmentId: Int) {
    getAllEmployees(search: $search, departmentId: $departmentId) {
      id
      firstName
      lastName
      email
      status
    }
  }
`;

export const GET_BRANCH_NAMES = gql`
  query branches($search: String) {
    branches(search: $search) {
      id
      branchName
      address
      city
      state
      email
    }
  }
`;

export const GET_ALL_PROJECTS = gql`
  query listProjects($search: String) {
    listProjects(search: $search) {
      id
      projectCode
      projectName
      totalProjectCost
      description
      revenueBudget
      branchId
      billingMethod
      partnerId
      partner {
        id
        displayName
      }
    }
  }
`;

// export const GET_ALL_PROJECTS_PAGINATION = gql`
//   query findAllProjectsWithPagination(
//     $limit: Int!
//     $skip: Int!
//     $search: String
//   ) {
//     findAllProjectsWithPagination(limit: $limit, skip: $skip, search: $search) {
//       projects {
//         id
//         projectCode
//         projectName
//         totalProjectCost
//         billingMethod
//         partnerId
//         partner {
//           displayName
//         }
//         projectWorkOrder {
//           workOrderNo
//           id
//         }
//         projectWorkOrders {
//           id
//           workOrderNo
//           branchId
//         }
//       }
//       total
//       limit
//       skip
//     }
//   }
// `;

export const LIST_PROJECTS_BY_EMPLOYEE = gql`
  query getProjectsByEmployee($id: Int) {
    getProjectsByEmployee(id: $id) {
      id
      projectCode
      projectName
      totalProjectCost
      description
      startDate
      endDate
      status
      budget
      threshold
      billingMethod
      costBudget
      revenueBudget
      branchId
      branchData {
        id
        branchName
      }
      costCenterId
      partnerId
      partner {
        id
        partnerType
        customerType
        displayName
      }
      projectTasks {
        id
        taskName
      }
      projectInvoices {
        id
        projectModelId
        invoiceNo
        orderNo
        invoiceDate
        paymentTerm
        paymentStatus
        reason
        dueDate
        subject
        customerNote
        isPayment
        subTotal
        tax
        adjustment
        totalPrice
        invoiceUrl
        balance
        status
      }
      quotes {
        id
        parentQuoteId
        quoteCode
        partnerId
        TRN
        SOW
        quoteDate
        expiryDate
        approvalDate
        createdBy
        branchId
        billingAddressId
        shippingAddressId
        refNumber
        projectId
        newProjectName
        quoteTitle
        subject
        subTotal
        tax
        adjustment
        totalAmount
        paymentTerm
        deliveryTerm
        validity
        termsCondition
        customerNote
        additionalNote
        quoteUrl
        status
      }
      parentQuotes {
        id
        parentCode
        quoteCode
        quoteDate
        partnerId
        projectId
        parentQuoteStatus
      }
    }
  }
`;

export const GET_SINGLE_PROJECT = gql`
  query projectDetail($id: Int!) {
    projectDetail(id: $id) {
      id
      projectCode
      projectName
      totalProjectCost
      description
      threshold
      billingMethod
      costBudget
      revenueBudget
      branchId
      costCenterId
      partnerId
      locationId
      projectTasks {
        id
        taskName
        description
      }
      projectResources {
        id
        projectId
        employeeId
        employeeData {
          firstName
          lastName
          email
        }
        status
      }
    }
  }
`;

export const OVERVIEW_COST = gql`
  query projectOverviewCost($id: Int!) {
    projectOverviewCost(id: $id) {
      project {
        id
        projectCode
        projectName
        totalProjectCost
        description
        startDate
        endDate
        status
        budget
        threshold
        billingMethod
        costBudget
        revenueBudget
      }
      totalNetPrice
      variationQuoteSum
    }
  }
`;

export const OVERVIEW_LIST = gql`
  query projectOverviewList($id: Int!) {
    projectOverviewList(id: $id) {
      id
      projectCode
      projectName
      totalProjectCost
      description
      startDate
      endDate
      status
      budget
      threshold
      billingMethod
      costBudget
      revenueBudget
      partnerId
      totalCredit
      totalDebit
      paidInvoices {
        invoiceNo
        tax
      }
      paidBills {
        billNo
        tax
      }
      partner {
        id
        partnerType
        customerType
        displayName
        paymentTerm
        companyName
        email
        phone
      }
      purchaseOrders {
        id
        projectId
        customerId
        billDate
        billingAddressId
        shippingAddressId
        purchaseOrderNo
        reference
        totalPrice
        subTotal
        currencyId
        vendor {
          displayName
        }
      }
      projectInvoices {
        invoiceNo
        invoiceDate
        status
        subTotal
        dueDate
        balance
        notes {
          noteType
          noteNo
          subTotal
        }
        paymentInfos {
          refType
          refId
          amount
        }
      }
      projectTasks {
        id
        taskName
        description
      }
      projectResources {
        id
        projectId
        employeeData {
          firstName
          lastName
          designation {
            designationName
          }
        }
        status
      }
      quotes {
        id
        parentQuoteId
        quoteDate
        expiryDate
        approvalDate
        createdBy
        newProjectName
        quoteTitle
        subTotal
        tax
        adjustment
        totalAmount
      }
      parentQuotes {
        id
        parentCode
        quoteCode
        quoteDate
        partnerId
      }
      projectWorkOrders {
        id
        workOrderStatus
        totalAmount
        workOrderNo
        partnerId
        quoteData {
          quoteCode
        }
      }
      pettyCash {
        id
        flow
        pettyCashNumber
        amount
      }
      projectBills {
        billData {
          noteNo
          noteType
          subTotal
        }
        paymentInfos {
          refType
          refId
          amount
        }
      }
    }
  }
`;

export const GET_LOCATIONS = gql`
  query locations($search: String) {
    locations(search: $search) {
      id
      locationName
      latitude
      longitude
    }
  }
`;

export const GET_PROJECT_OVERVIEW_COUNTS = gql`
  query getProjectOverviewCounts($projectId: Int!) {
    getProjectOverviewCounts(id: $projectId) {
      bills
      quotes
      invoices
      workOrders
      purchaseOrders
      localPurchaseOrders
      goodsReceivedCount
      paymentReceived
      paymentMade
      totalExpense
      pettyCashUsed
      invoiceTotal
      variationQuotes
      variationQuoteSum
      purchaseOrderSubTotal
      localPurchaseOrderSubTotal
    }
  }
`;

export const GET_INCOME_AND_EXPENSE = gql`
  query getIncomeAndExpense($projectId: Int!, $year: Int!) {
    getIncomeAndExpense(projectId: $projectId, year: $year) {
      month
      totalIncome
      totalExpense
    }
  }
`;

export const PROJECT_ITEM_SUMMARY = gql`
  query projectItemSummaryById($projectId: Float!) {
    projectItemSummaryById(projectId: $projectId) {
      projectId
      projectName
      totalProjectPrice
      items {
        itemId
        itemName
        finalQuantity
        unitPrice
        totalPrice
      }
    }
  }
`;

export const GET_UNUSED_ITEMS_BY_PROJECT = gql`
  query getUnusedItemsByProject($id: Int!) {
    getUnusedItemsByProject(id: $id) {
      itemId
      itemName
      quantity
    }
  }
`;

export const LIST_ALL_PROJECTS = gql`
  query projects($search: String) {
    projects(search: $search) {
      id
      branchData {
        id
        branchName
        address
        branchCode
        employeeCount
      }
      quoteId
      quoteData {
        id
        quoteCode
      }
      orderId
      orderData {
        id
        orderCode
      }
      customerId
      customerData {
        id
        firstName
        lastName
        email
        phoneNumber
        address
        city
        state
        country
        zipCode
      }
      projectCode
      projectName
      projectCost
      startDate
      endDate
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const LIST_ALL_PROJECTS_PAGINATION = gql`
 query findAllProjectsWithPagination($input: ProjectPaginationInput) {
  findAllProjectsWithPagination(input: $input) {
    projects {
      id
      projectName
      projectCode
      projectCost
      startDate
      endDate
      branchData {
        id
        branchName
      }
      quoteData {
        id
        quoteCode
      }
      orderData {
        id
        orderCode
      }
      customerData {
        id
        firstName
        lastName
      }
    }
    total
    skip
    limit
  }
}

 `;

export const GET_PROJECT_BY_ID = gql`
  query project($id: Int!) {
    project(id: $id) {
      id
      branchId
      branchData {
        id
        branchName
        address
        branchCode
      }
      quoteId
      quoteData {
        id
        quoteCode
        version
        validUntil
        quoteDate
        subTotal
        tax
        discount
        totalAmount
        discountValue
        paymentTerms
        approvalDate
      }
      orderId
      orderData {
        id
        branchId
        orderCode
        orderDate
        totalAmount
        received
        balance
        refund
        paymentStatus
        isRefund
        reason
      }
      customerId
      customerData {
        id
        firstName
        lastName
        email
        phoneNumber
        address
        city
        state
        country
        zipCode
        dateOfBirth
      }
      projectCode
      projectName
      projectCost
      startDate
      endDate
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;
